import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../store/auth'
import { Botao, Erro } from '../components/ui'

/**
 * A senha vai direto do formulário para o Upgrade ID e some.
 *
 * Nunca passa pelo coletor e nunca é guardada. O que fica no navegador é o
 * token, que expira sozinho.
 */
export default function Login() {
  const entrar = useAuth((s) => s.entrar)
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [indo, setIndo] = useState(false)

  async function enviar(e) {
    e.preventDefault()
    setErro(''); setIndo(true)
    try {
      await entrar(email, senha)
    } catch {
      // Sem distinguir "senha errada" de "e-mail não existe": distinguir ajuda
      // mais quem está tentando adivinhar do que quem esqueceu a senha.
      setErro('Não foi possível entrar. Confira e-mail e senha.')
    } finally { setIndo(false) }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6">
      <form onSubmit={enviar} className="flex w-full max-w-sm flex-col gap-4 rounded-xl border border-zinc-200 bg-white p-7">
        <div>
          <h1 className="text-lg font-semibold text-zinc-900">Modelos</h1>
          <p className="text-sm text-zinc-500">Console do registro central</p>
        </div>
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="e-mail" autoComplete="username"
          className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
        />
        <input
          type="password" required value={senha} onChange={(e) => setSenha(e.target.value)}
          placeholder="senha" autoComplete="current-password"
          className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
        />
        <Erro>{erro}</Erro>
        <Botao type="submit" disabled={indo}>{indo ? 'entrando…' : 'Entrar'}</Botao>
        <Link to="/esqueci" className="text-center text-sm text-zinc-500 hover:text-zinc-800">
          esqueci a senha
        </Link>
        <p className="text-[11px] leading-relaxed text-zinc-400">
          Autenticação pelo Upgrade&nbsp;ID. Só e-mails listados em
          <span className="font-mono"> REGISTRY_ADMINS</span> conseguem abrir o console.
        </p>
      </form>
    </div>
  )
}
